export default __webpack_public_path__ + "e21e16de3218e9a1f8b6d3f8de9a5dc3.png";